<div class="component-container flex flex-col justify-center items-center">
  <div
    class="heading flex justify-center">
    Edit Phone Number
  </div>
  <div
    class="message"
  >
    Please enter your phone number to receive a verification code to verify your account
  </div>
  <form class="flex flex-col justify-center items-center w-full">
    <app-phone-number-input
      class="w-3/4"
      [parentFormGroup]="form"
      controlName="phoneNumber"
      placeholder="Phone Number"
      type="small"
      label="Phone Number"
      suffixIcon="edit"
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['phoneNumber']"
      (handleSuffixClick)="handleSuffixClick()"
    ></app-phone-number-input>
    <div
      *ngIf="otpSent"
      class="otp-section flex flex-col justify-center items-center"
    >
      <div class="label flex justify-center">
        Enter Verification Code
        <span
          class="required-mark font-work-sans"
        >*</span>
      </div>
      <app-otp-input
        class="otp-input w-full"
        [parentFormGroup]="form"
        controlName="otp"
        [error]="errorMessages['otp']"
        (keyup.enter)="verifyOtp()"
      ></app-otp-input>
    </div>
    <app-primary-button
      class="get-otp-btn w-[70%] flex justify-center"
      type="small"
      (click)="otpSent ? verifyOtp() :getOtp()"
      [isLoading]="generateOtpLoading || verifyOtpLoading"
      [isDisabled]="!form.controls['phoneNumber'].dirty && !otpSent"
    >
      {{otpSent ? 'Enter Verification Code' : 'Send Verification Code'}}
    </app-primary-button>
  </form>
</div>
